var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "custom-class": "layout-dialog building_work",
        title: "建物",
        top: "5vh",
        width: "900px",
        visible: _vm.visible,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.close,
      },
    },
    [
      _c("div", { staticClass: "flex_start flex_center_align mb6" }, [
        _c("div", { staticClass: "split_line" }),
        _c("span", { staticClass: "box_title" }, [_vm._v("建物情報")]),
      ]),
      _c(
        "div",
        { staticClass: "sure_box top_info mtn mb12" },
        [
          _c(
            "vab-row",
            { staticClass: "row_box" },
            [
              _c("vab-col", { staticClass: "title_box", attrs: { span: 4 } }, [
                _vm._v("建物"),
              ]),
              _c("vab-col", { staticClass: "word_box", attrs: { span: 20 } }, [
                _c("div", { staticClass: "flex_space flex_center_align" }, [
                  _c("div", { staticClass: "flex_auto line_height" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.getFieldValue("blgsrnnm", _vm.dataList)) +
                        " "
                    ),
                  ]),
                  _c("div", { staticClass: "sub_title" }, [
                    _vm._v(
                      " （建物CD：" +
                        _vm._s(_vm.getFieldValue("buildingCd", _vm.dataList)) +
                        "） "
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "vab-row",
            { staticClass: "row_box" },
            [
              _c("vab-col", { staticClass: "title_box", attrs: { span: 4 } }, [
                _vm._v("住所"),
              ]),
              _c("vab-col", { staticClass: "word_box", attrs: { span: 20 } }, [
                _c("div", { staticClass: "flex_space flex_center_align" }, [
                  _c("div", { staticClass: "flex_auto line_height" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.getFieldValue("adr1", _vm.dataList)) +
                        " " +
                        _vm._s(_vm.getFieldValue("adr2", _vm.dataList)) +
                        " "
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "vab-row",
            { staticClass: "row_box" },
            [
              _c("vab-col", { staticClass: "title_box", attrs: { span: 4 } }, [
                _vm._v("郵便番号"),
              ]),
              _c("vab-col", { staticClass: "word_box", attrs: { span: 8 } }, [
                _c("div", { staticClass: "flex_space flex_center_align" }, [
                  _c("div", { staticClass: "flex_auto line_height" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.getFieldValue("postno", _vm.dataList)) +
                        " "
                    ),
                  ]),
                ]),
              ]),
              _c("vab-col", { staticClass: "title_box", attrs: { span: 4 } }, [
                _vm._v("管理事務室電話番号"),
              ]),
              _c("vab-col", { staticClass: "word_box", attrs: { span: 8 } }, [
                _c("div", { staticClass: "flex_space flex_center_align" }, [
                  _c("div", { staticClass: "flex_auto line_height" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.getFieldValue("mgotel", _vm.dataList)) +
                        " "
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "vab-row",
            { staticClass: "row_box" },
            [
              _c("vab-col", { staticClass: "title_box", attrs: { span: 4 } }, [
                _vm._v("担当部門"),
              ]),
              _c("vab-col", { staticClass: "word_box", attrs: { span: 8 } }, [
                _c("div", { staticClass: "flex_space flex_center_align" }, [
                  _c("div", { staticClass: "flex_auto line_height" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.getFieldValue("orgkj", _vm.dataList)) +
                        " "
                    ),
                  ]),
                  _c("div", { staticClass: "sub_title" }, [
                    _vm._v(
                      " （部門CD：" +
                        _vm._s(_vm.getFieldValue("pstsctcd", _vm.dataList)) +
                        "） "
                    ),
                  ]),
                ]),
              ]),
              _c("vab-col", { staticClass: "title_box", attrs: { span: 4 } }, [
                _vm._v("担当者"),
              ]),
              _c("vab-col", { staticClass: "word_box", attrs: { span: 8 } }, [
                _c("div", { staticClass: "flex_space flex_center_align" }, [
                  _c("div", { staticClass: "flex_auto line_height" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.getFieldValue("chrnm", _vm.dataList)) +
                        " "
                    ),
                  ]),
                  _c("div", { staticClass: "sub_title" }, [
                    _vm._v(
                      " （担当者CD：" +
                        _vm._s(_vm.getFieldValue("chempcd", _vm.dataList)) +
                        "） "
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "vab-row",
            { staticClass: "row_box" },
            [
              _c("vab-col", { staticClass: "title_box", attrs: { span: 4 } }, [
                _vm._v("キーボックスパスワード"),
              ]),
              _c("vab-col", { staticClass: "word_box", attrs: { span: 20 } }, [
                _c("div", { staticClass: "flex_space flex_center_align" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.getFieldValue(
                          "exBuildingKeyboxModel.passcode",
                          _vm.dataList
                        )
                      ) +
                      " "
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "flex_start flex_center_align mb6" }, [
        _c("div", { staticClass: "split_line" }),
        _c("span", { staticClass: "box_title" }, [_vm._v("FM勤務情報")]),
      ]),
      _c(
        "div",
        { staticClass: "sure_box top_info mtn" },
        [
          _c(
            "vab-row",
            { staticClass: "row_box" },
            [
              _c(
                "vab-col",
                { staticClass: "table_header br", attrs: { span: 12 } },
                [_vm._v("氏名")]
              ),
              _c(
                "vab-col",
                { staticClass: "table_header", attrs: { span: 12 } },
                [_vm._v("勤務日／勤務時間")]
              ),
            ],
            1
          ),
          _vm.dataList.fmWorkTimes.length > 0
            ? _vm._l(_vm.dataList.fmWorkTimes, function (itm, idx) {
                return _c(
                  "vab-row",
                  { key: idx, staticClass: "row_box" },
                  [
                    _c(
                      "vab-col",
                      {
                        staticClass: "word_box8 br flex_center_align",
                        attrs: { span: 12 },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.getFieldValue("empnmkj", itm)) + " "
                        ),
                      ]
                    ),
                    _c(
                      "vab-col",
                      {
                        staticClass: "word_box8 br flex_center_align",
                        attrs: { span: 12 },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.getFieldValue("knmfrdow", itm)) +
                            " " +
                            _vm._s(
                              _vm.getFieldValue("knmfrdow", itm) ? "/" : ""
                            ) +
                            " " +
                            _vm._s(
                              _vm._f("timeChange")(
                                _vm.getFieldValue("knmstrtm", itm)
                              )
                            ) +
                            " " +
                            _vm._s(itm.knmstrtm === "" ? "" : "~") +
                            " " +
                            _vm._s(
                              _vm._f("timeChange")(
                                _vm.getFieldValue("knmendtm", itm)
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              })
            : [
                _c(
                  "vab-row",
                  [
                    _c(
                      "vab-col",
                      {
                        staticClass: "word_box8 br flex_center_align text_set",
                        attrs: { span: 24 },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "validateMessage." +
                                  _vm.$messageCode.E00000104.name
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "flex_end", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "div",
            { staticClass: "flex_start flex_center_align" },
            [_c("vab-button", { attrs: { "btn-list": _vm.btnList } })],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }